import { Directive, ElementRef, OnInit, Renderer2 } from "@angular/core";

@Directive({ selector: "[appBackgroundImage]" })
export class BackgroundImageDirective implements OnInit {
  private counter: number = 0; // eslint-disable-line
  private maxAttempts: number = 20; // eslint-disable-line

  constructor(private renderer: Renderer2, private el: ElementRef<HTMLElement>) {}

  public ngOnInit(): void {
    const interval = setInterval(() => {
      this.counter++;
      const image = this.el.nativeElement.getAttribute("data-image");

      if (image) {
        clearInterval(interval);
        this.renderer.setStyle(
          this.el.nativeElement,
          "backgroundImage",
          `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url('${image}')`,
        );
      }

      if (this.counter > this.maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

}
